export enum MutationTypes {
  TOGGLE_DIALOG = 'TOGGLE_DIALOG',
  UPDATE_PAYMENTS = 'UPDATE_PAYMENTS',
  SET_NOTIFICATION = 'SET_NOTIFICATION'
}
